import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { BsInfoCircleFill } from "react-icons/bs";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaCopy } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import Addgroup from './addgroup';

const API_URL = process.env.REACT_APP_API_BASE || "https://wa-api.globebot.io";

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return {};
    }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

// Helper: Validate a mobile number value for either 10 or 12 digits, and only valid digits
function isValidNumber(input) {
    // Should be all digits and 10 or 12 digits
    if (!input) return false;
    const cleaned = input.replace(/\D/g, '');
    if (!/^\d+$/.test(cleaned)) return false;
    if (cleaned.length === 10 || cleaned.length === 12) return true;
    return false;
}

// Simple confirmation modal component
function ConfirmModal({ open, title, message, onConfirm, onCancel, loading = false }) {
    if (!open) return null;
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.2)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            <div className="bg-white dark:bg-[#23272F] p-6 rounded-md shadow-md min-w-[300px] max-w-[90vw]" style={{ maxWidth: 400 }}>
                <h3 className="font-bold text-[18px] mb-2">{title || "Confirm Action"}</h3>
                <div className="mb-4">{message}</div>
                <div className="flex justify-end gap-2">
                    <button
                        className='bg-[#d3dde6] rounded px-4 py-2 font-semibold text-[#555]' 
                        onClick={onCancel}
                        disabled={loading}
                    >Cancel</button>
                    <button
                        className='bg-[#ed5050] rounded px-4 py-2 font-semibold text-white'
                        onClick={onConfirm}
                        disabled={loading}
                    >{loading ? "Deleting..." : "Delete"}</button>
                </div>
            </div>
        </div>
    );
}

// Helper to download sample CSV
function downloadSampleCSV() {
    // This is a simple CSV for example purposes (add more rows if needed)
    const content = `number
9123456789
919876543210
`;
    const blob = new Blob([content], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = "blacklist_sample.csv";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }, 0);
}

function BlackListNumbers() {
    const [open, setopen] = useState(false);
    const [showfilter, setshowfilter] = useState(false);
    const [Number, setNumber] = useState('');
    const [isNumber, setisNumber] = useState('Number');
    const [wabadata, setWabadata] = useState([]);
    const [blacklist, setBlacklist] = useState([]);
    const [loading, setLoading] = useState(false);
    const { userId, token } = getUserIdFromToken();

    // error state for validation feedback
    const [numberErrors, setNumberErrors] = useState([]);
    const [excelError, setExcelError] = useState('');
    // For selecting rows
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    // For delete modals
    const [showSingleDeleteModal, setShowSingleDeleteModal] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
    const [isBulkDeleting, setIsBulkDeleting] = useState(false);

    // Fetch WABA Data
    useEffect(() => {
        if (!token) return;
        fetch(`${API_URL}/auth/my-whatsapp`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) setWabadata(data);
                else if (data && Array.isArray(data.data)) setWabadata(data.data);
                else setWabadata([]);
            })
            .catch(() => setWabadata([]));
    }, [token]);

    // Fetch blacklist data, filtered by number if present
    useEffect(() => {
        if (!token || !wabadata[0]?.waba_id) return;
        setLoading(true);
        let url = `${API_URL}/auth/blacklist`;
        let params = [`waba_id=${wabadata[0]?.waba_id}`];
        fetch(`${url}/${wabadata[0]?.waba_id}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(res => res.json())
            .then(res => {
                if (Array.isArray(res)) setBlacklist(res);
                else if (res?.data && Array.isArray(res.data)) setBlacklist(res.data);
                else setBlacklist([]);
                setLoading(false);
                setSelectedIds([]); // Reset selections on fetch
                setSelectAll(false);
            })
            .catch(() => {
                setBlacklist([]);
                setLoading(false);
                setSelectedIds([]);
                setSelectAll(false);
            });
    }, [token, wabadata, Number]);

    function handleFilter() {
        // Filtering reuses effect since Number is in deps; just triggers re-fetch
        setNumber(Number);
    }

    function clearFilter() {
        setNumber('');
    }

    // Select row logic
    function toggleSelect(id) {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    }
    function toggleSelectAll() {
        if (selectAll) {
            setSelectedIds([]);
            setSelectAll(false);
        } else {
            const allIds = blacklist.map(item => item.id || item._id);
            setSelectedIds(allIds);
            setSelectAll(true);
        }
    }
    useEffect(() => {
        // Sync SelectAll checkbox
        if (blacklist.length === 0) {
            setSelectAll(false);
        } else if (selectedIds.length === blacklist.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }, [selectedIds, blacklist]);

    // Add Blacklist (single or excel)
    const [textareaValue, setTextareaValue] = useState('');
    const [excelFile, setExcelFile] = useState(null);
    const [adding, setAdding] = useState(false);

    // Send numbers one by one in parallel (fast) as separate requests
    function handleAddBlacklist() {
        if (!token || !wabadata[0]?.waba_id) return;
        setNumberErrors([]);
        setExcelError('');
        setAdding(true);

        let url = `${API_URL}/auth/blacklist`;

        if (isNumber === 'Number') {
            // Clean/split numbers: support comma/line
            let arr =
                textareaValue
                    .split(/[\n,]/)
                    .map(i => i.trim())
                    .filter(Boolean);

            // Validation: filter only valid numbers
            const invalidNumbers = arr.filter(
              number => !isValidNumber(number)
            );
            if (invalidNumbers.length > 0) {
                setNumberErrors(invalidNumbers);
                setAdding(false);
                return;
            }

            // Prepare all requests (Promise.all for speed)
            const requests = arr.map(number =>
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        wabaId: wabadata[0].waba_id,
                        number: number,
                    })
                }).then(res => res.json())
            );

            Promise.all(requests)
                .then(() => {
                    setAdding(false);
                    setopen(false);
                    setTextareaValue('');
                    setNumberErrors([]);
                    // Refetch
                    setNumber('');
                })
                .catch(() => setAdding(false));
        } else if (isNumber === 'Excel' && excelFile) {
            // NOTE: No strict number-level validation for excel upload, since parsing file is not done in frontend
            // Could give a tip instead
            let formData = new FormData();
            formData.append('waba_id', wabadata[0].waba_id);
            formData.append('file', excelFile);

            fetch(url + '/excel', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
            })
                .then(res => res.json())
                .then(() => {
                    setAdding(false);
                    setopen(false);
                    setExcelFile(null);
                    setExcelError('');
                    // Refetch
                    setNumber('');
                })
                .catch(() => {
                    setAdding(false);
                    setExcelError('Failed to upload excel. Please make sure it contains valid numbers only.');
                });
        }
        window.location.reload();
   
    }

    // Handle delete single (by id) - now asks for confirmation
    function askSingleDelete(id) {
        setDeletingId(id);
        setShowSingleDeleteModal(true);
    }
    function handleSingleDeleteConfirmed() {
        if (!token || !wabadata[0]?.waba_id || !deletingId) return;
        setIsDeleting(true);
        fetch(`${API_URL}/auth/blacklist/${deletingId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(res => res.json())
            .then(() => {
                setBlacklist(prev => prev.filter(item => (item.id || item._id) !== deletingId));
                setSelectedIds(prev => prev.filter(x => x !== deletingId));
                setShowSingleDeleteModal(false);
                setDeletingId(null);
                setIsDeleting(false);
            })
            .catch(() => {
                setShowSingleDeleteModal(false);
                setDeletingId(null);
                setIsDeleting(false);
            });
    }

    // Bulk delete selected
    function askBulkDelete() {
        setShowBulkDeleteModal(true);
    }
    function handleBulkDeleteConfirmed() {
        if (!token || !wabadata[0]?.waba_id || selectedIds.length === 0) {
            setShowBulkDeleteModal(false);
            return;
        }
        setIsBulkDeleting(true);

        // Make all delete requests, then refetch
        const requests = selectedIds.map(id =>
            fetch(`${API_URL}/auth/blacklist/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            }).then(res => res.json())
        );
        Promise.all(requests)
            .then(() => {
                setBlacklist(prev => prev.filter(item => !selectedIds.includes(item.id || item._id)));
                setSelectedIds([]);
                setShowBulkDeleteModal(false);
                setIsBulkDeleting(false);
            })
            .catch(() => {
                setShowBulkDeleteModal(false);
                setIsBulkDeleting(false);
            });
    }

    return (
        <>
            <div className='px-2 dark:bg-[#121519] h-[100vh] pl-4 pr-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 w-[100%]'>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff] flex items-center'>
                        <Link to='/configuration'><FaArrowLeftLong /></Link>
                        BlackList Numbers
                    </h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>
                        <span>WhatsApp</span>
                        <IoIosArrowForward />
                        <span>BlackList Numbers</span>
                    </div>
                </div>

                <div className='w-[100%] flex items-center justify-between mt-4'>
                    <button
                        onClick={() => setopen(true)}
                        className='hover:bg-[#3f7fca] hover:text-[#fff] border-[1px] border-[#3f7fca] text-[12px] flex items-center py-2 text-[#3f7fca]   px-4 rounded-md font-semibold gap-1'>
                        <MdAdd className='text-[16px] font-bold' />
                        BlackList Numbers
                    </button>
                    <button
                        onClick={() => {
                            if (selectedIds.length > 0) {
                                askBulkDelete();
                            }
                        }}
                        disabled={selectedIds.length === 0}
                        className={`hover:bg-[#ed5050] hover:text-[#fff] border-[1px] border-[#ed5050] text-[12px] flex items-center py-2 px-4 rounded-md font-semibold gap-1 ${selectedIds.length === 0 ? "opacity-50 cursor-not-allowed" : "text-[#ed5050]"}`}>
                        <RiDeleteBin5Line className=' text-[16px] font-bold' />
                        Delete Selected
                    </button>
                </div>

                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-4'>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Number</label>
                                <input
                                    value={Number}
                                    onChange={(e) => setNumber(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                                <button
                                    onClick={handleFilter}
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                    disabled={loading}
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>

                                <button
                                    onClick={clearFilter}
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                    disabled={loading}
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                }
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] mt-2">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <input
                                        type="checkbox"
                                        className='accent-[#37715d]'
                                        checked={selectAll}
                                        onChange={toggleSelectAll}
                                        aria-label="Select all"
                                    />
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Number</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>CreatedDate</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Actions</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={4} className="text-center text-gray-500 p-2">Loading...</td>
                            </tr>
                        ) : blacklist && blacklist.length > 0 ? (
                            blacklist.map(item => {
                                const id = item.id || item._id;
                                return (
                                    <tr
                                        key={id}
                                        className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                                    >
                                        <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.includes(id)}
                                                onChange={() => toggleSelect(id)}
                                                className='accent-[#37715d]'
                                                aria-label="Select Row"
                                            />
                                        </td>
                                        <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                            {item?.number}
                                        </td>
                                        <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                            {item?.createdAt
                                                ? new Date(item.createdAt).toLocaleString()
                                                : ''}
                                        </td>
                                        <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                            <div className='flex items-center gap-2'>
                                                <div
                                                    className='border-[#37715d] border-[1px] p-1 hover:bg-[#37715d] hover:text-[#fff] text-[#37715d] rounded-md group cursor-pointer'
                                                    title="Copy"
                                                    onClick={() => navigator.clipboard.writeText(item?.number || '')}
                                                >
                                                    <FaCopy className='text-[#37715d] group-hover:text-[#fff] text-[13px]' />
                                                </div>
                                                <div
                                                    className='border-[#ed5050] border-[1px] p-1 hover:bg-[#ed5050] hover:text-[#fff] text-[#ed5050] rounded-md group cursor-pointer'
                                                    title="Delete"
                                                    onClick={() => askSingleDelete(id)}
                                                >
                                                    <RiDeleteBin5Line className='text-[#ed5050] group-hover:text-[#fff] text-[13px]' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="4" className="p-1 text-[11px]">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <p className='text-[11px] text-[#3f7fc8] mt-2'>
                    Showing 1 to {blacklist?.length || 0} of {blacklist?.length || 0} records
                </p>
            </div>

            {/* Single Delete Confirmation Modal */}
            <ConfirmModal
                open={showSingleDeleteModal}
                onConfirm={handleSingleDeleteConfirmed}
                onCancel={() => { setShowSingleDeleteModal(false); setDeletingId(null); }}
                loading={isDeleting}
                title="Delete Number"
                message="Are you sure you want to delete this number from the blacklist?"
            />

            {/* Bulk Delete Confirmation Modal */}
            <ConfirmModal
                open={showBulkDeleteModal}
                onConfirm={handleBulkDeleteConfirmed}
                onCancel={() => setShowBulkDeleteModal(false)}
                loading={isBulkDeleting}
                title="Delete Selected"
                message={`Are you sure you want to delete ${selectedIds.length} selected blacklisted number${selectedIds.length > 1 ? 's' : ''}?`}
            />

            <Addgroup isOpen={open} onClose={() => setopen(false)} heading='BlacklistNumbers Info'>
                <div className='pt-2 pb-6 border-y-[1px] border-[#8b8a8a67] my-2 w-[100%]'>
                    <div className='flex w-[100%] gap-2'>
                        <button
                            onClick={() => setisNumber('Number')}
                            className={`${isNumber === 'Number' ? 'text-[#37715d] border-[#37715d] border-b-[2px]' : 'text-[#61748f]'} p-2 text-[13px] font-semibold`}>
                            Enter Number
                        </button>
                        <button
                            onClick={() => setisNumber('Excel')}
                            className={`${isNumber === 'Excel' ? 'text-[#37715d] border-[#37715d] border-b-[2px]' : 'text-[#61748f]'} p-2 text-[13px] font-semibold`}>
                            Upload Excel
                        </button>
                    </div>
                    {isNumber === 'Number' &&
                        <div className='w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
                                Enter Mobile Numbers (comma or line separated):
                            </label>
                            <textarea
                                rows={4}
                                value={textareaValue}
                                onChange={e => {
                                    setTextareaValue(e.target.value);
                                    setNumberErrors([]);
                                }}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            />
                            {numberErrors.length > 0 && (
                                <div className="mt-2 text-[#ed5050] text-[12px]">
                                    <span>Invalid numbers (must be 10 or 12 digits, only numbers):</span>
                                    <ul className="list-disc ml-4">
                                        {numberErrors.map((n, i) => (
                                            <li key={n + i}>{n}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    }
                    {isNumber === 'Excel' &&
                        <div className='w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#3f7fca] text-[12px] font-semibold dark:text-[#fff]'>Upload Excel File:</label>
                            <input
                                type="file"
                                accept=".xls,.xlsx"
                                onChange={e => {
                                    setExcelFile(e.target.files?.[0] || null);
                                    setExcelError('');
                                }}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            />
                            <p className='w-[100%] flex justify-between text-[#ed5050] text-[12px] font-semibold'>
                                (Note: Supports only .xls or .xlsx Files)
                                <span
                                    className='underline cursor-pointer text-blue-600 dark:text-blue-400'
                                    onClick={downloadSampleCSV}
                                    tabIndex={0}
                                    role="button"
                                    aria-label="Download sample blacklist csv file"
                                >
                                    Sample File
                                </span>
                            </p>
                            {excelError && <div className="mt-2 text-[#ed5050] text-[12px]">{excelError}</div>}
                        </div>
                    }
                </div>
                <div className='w-[100%] flex justify-end gap-1'>
                    <button
                        disabled={adding}
                        onClick={handleAddBlacklist}
                        className='p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff]' >
                        {adding ? "Saving..." : "Save"}
                    </button>
                    <button
                        onClick={() => setopen(false)}
                        className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'>
                        Close
                    </button>
                </div>
            </Addgroup>
        </>
    );
}

export default BlackListNumbers